<template>
    <table class="table table-condensed">
        <thead>
        <tr>
            <td>Handelsnaam</td>
            <td> {{kvkData.mainItem.tradeNames.businessName ? kvkData.mainItem.tradeNames.businessName:
                kvkData.mainItem.tradeNames.shortBusinessName}}
            </td>
        </tr>
        </thead>
        <tbody>
        <tr>
            <th colspan="2">Adres</th>
        </tr>
        <tr>
            <td>Straat</td>
            <td>{{kvkData.adres.street}} {{kvkData.adres.houseNumber}}
                {{kvkData.adres.houseNumberAddition}}
            </td>
        </tr>
        <tr>
            <td>Postcode</td>
            <td>{{kvkData.adres.postalCode}} {{kvkData.adres.city}}</td>
        </tr>
        <tr v-if="kvkData.mainItem.websites">
            <th colspan="2">Website(s)</th>
        </tr>
        <tr v-for="website in kvkData.mainItem.websites" :key="website">
            <td>Url</td>
            <td>{{website}}</td>
        </tr>
        </tbody>
    </table>
</template>

<script>
  export default {
    name: 'KvkSummary',
    props: {
      kvkData: Object
    },
  }
</script>

<style scoped>

</style>
